import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const Convergence2023Overview = () => {
  const path = "Convergence-2023%2FOverview";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-overview-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023OverviewStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div>&nbsp;</div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      <div>&nbsp;</div>
    </>
  );
};

export default Convergence2023Overview;

const Convergence2023OverviewStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .sm-text {
            font-size: 18px;
            color: #19204A;
            font-weight: bold;
          }
          .lg-caption {
            font-size: xx-large;
            font-weight: bold;
            color: #94264F;
          }
          .icons-list {
            margin-bottom: 20px;
          }
          .icons-list img {
            height: 100px;
            margin-bottom: 25px;
          }
          .topics ul li { padding-bottom: 4px; }
          .features img { width: 350px }
          h4 a { text-decoration: underline; color: #19204A; }
          .social-media-icons a {
            padding-right: 7px;
           }
        `}
      </style>
    </>
  );
};
